import { useMemo } from 'react';

import { LegalClientsListItemData } from 'api/types/data';
import { formatToDate } from 'helpers';
import { useConvertDateToUserTimezone } from 'hooks';

import { ClientsListItem } from '../../types';

import { useColumns } from './columns';

const getLastSessionDate = (
  client: LegalClientsListItemData,
  convertDateToUserTimezone: (date: Date) => Date
): string | undefined => {
  const { lastSessionDate } = client;

  if (!lastSessionDate) {
    return undefined;
  }

  return formatToDate(convertDateToUserTimezone(lastSessionDate));
};

const getPersonalAccountOpeningDate = (
  client: LegalClientsListItemData,
  convertDateToUserTimezone: (date: Date) => Date
): string | undefined => {
  const { personalAccountOpeningDate } = client;

  if (!personalAccountOpeningDate) {
    return undefined;
  }

  return formatToDate(convertDateToUserTimezone(personalAccountOpeningDate));
};

export const useLegalClientsTable = (clients: LegalClientsListItemData[]) => {
  const { convertDateToUserTimezone } = useConvertDateToUserTimezone();

  const rows = useMemo(
    () =>
      clients.map((client) => ({
        ...client,
        lastSessionDate: getLastSessionDate(client, convertDateToUserTimezone),
        personalAccountOpeningDate: getPersonalAccountOpeningDate(
          client,
          convertDateToUserTimezone
        ),
      })) as ClientsListItem[],
    [clients, convertDateToUserTimezone]
  );

  const columns = useColumns();

  return { rows, columns };
};
